import { AubadeComponent } from "js/front/bootstrap";
import Draggable from "gsap/Draggable";
import gsap from "gsap";
import { customization } from "storage";

class CartItem extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        this.popin = this.element.querySelector("[data-component='Popin']");
        this.quantityInput = this.element.querySelector(".input-wrapper input");
        this.removeButton = this.element.querySelector(".remove");
        this.removeMb = this.element.querySelector(".remove-mobile");
    }

    init() {
        this.cPopin = this.components.get(this.popin);
    }

    attach() {
        this.removeButton.addEventListener("click", this.onClickRemove);
        this.removeMb.addEventListener("click", this.onClickRemove);
    }
    detach() {
        this.removeButton.removeEventListener("click", this.onClickRemove);
        this.removeMb.removeEventListener("click", this.onClickRemove);
    }

    onClickRemove = () => {
        customization.set(this.element.dataset.code, 0);
        customization.remoteSave();
    };
}

export { CartItem };
